module.exports = __webpack_public_path__ + "static/cgl-logo-0a638554fcb5889aba71c8bf8a0552c3.png";